import { Box, Typography, TableContainer, Table, TableHead, TableRow, TableCell, Paper, TableBody, TablePagination, Chip, Checkbox, Button, LinearProgress } from '@mui/material'
import { useInsumo } from '../../../../shared/context/insumoContext'
import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { useUtiles } from '../../../../shared/context/utilesContext'
import DeleteIcon from '@mui/icons-material/Delete'
import { useAbility } from '../../../../shared/context/AbilityContext'

export default function ListComponent() {
    const { insumos, getInsumos, pagination, setPagination, resetInsumo, filtersData, selectedInsumoToDelete, setSelectedInsumoToDelete, loadingDeleteInsumos, deleteInsumos } = useInsumo()
    const { locationString } = useUtiles()
    useEffect(() => {
        getInsumos()
        resetInsumo()
    }, [])
    const navigate = useNavigate()
    const handleEditInsumo = (hash) => {
        navigate(`/insumos/editar/${hash}`)
    }


    const handleCheckboxChange = (id) => {
        setSelectedInsumoToDelete(prev => {
            if (prev.includes(id)) {
                return prev.filter(itemId => itemId !== id);
            } else {
                return [...prev, id];
            }
        });
    };

    const ability = useAbility();



    return (
        <>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1, mt: 1, bgcolor: 'background.paper', borderRadius: '10px' }}>
                <Typography variant="body1">
                    {selectedInsumoToDelete.length} {selectedInsumoToDelete.length === 1 ? 'elemento seleccionado' : 'elementos seleccionados'}
                </Typography>
              {ability.can('delete', 'RESOURCES') && <Button
                    disabled={selectedInsumoToDelete.length === 0 || loadingDeleteInsumos}
                    size="small"
                    variant="contained"
                    color="error"
                    startIcon={<DeleteIcon />}
                    onClick={() => {
                        deleteInsumos()
                    }}
                >
                    Eliminar seleccionados
                </Button>}
            </Box>
            {loadingDeleteInsumos && (
                <LinearProgress />
            )}

            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1, mt: 1, bgcolor: 'background.paper', borderRadius: '10px' }}>
                <Typography variant="body1">

                </Typography>


                <TableContainer component={Paper} sx={{ "&.MuiPaper-root": { borderRadius: '10px', boxShadow: 'none' }, height: '70vh', overflow: 'auto' }}>
                    <Table sx={{ minWidth: 1800, overflowX: 'auto' }} aria-label="simple table" stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 'bold', backgroundColor: 'background.paper', width: '50px' }}>
                                    {ability.can('delete', 'RESOURCES') && (
                                        <Checkbox
                                            color="secondary"
                                            checked={insumos.length > 0 && selectedInsumoToDelete.length === insumos.length}
                                            indeterminate={selectedInsumoToDelete.length > 0 && selectedInsumoToDelete.length < insumos.length}
                                            onChange={(e) => {
                                                if (e.target.checked) {
                                                    setSelectedInsumoToDelete(insumos.map(insumo => insumo.id));
                                                } else {
                                                    setSelectedInsumoToDelete([]);
                                                }
                                            }}
                                        />
                                    )}
                                </TableCell>
                                <TableCell sx={{ fontWeight: 'bold', backgroundColor: 'background.paper', width: '80px' }}>Habilitado</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', backgroundColor: 'background.paper', width: '150px' }}>Codigo</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', backgroundColor: 'background.paper', width: '250px' }}>Nombre</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', backgroundColor: 'background.paper', width: '100px' }}>Cantidad</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', backgroundColor: 'background.paper', width: '200px' }}>Unidad de medida</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', backgroundColor: 'background.paper', width: '250px' }}>Tipo</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', backgroundColor: 'background.paper', width: '350px' }}>Ubicación</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', backgroundColor: 'background.paper', width: '300px' }}>Descripción</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', backgroundColor: 'background.paper', width: '150px' }}>Fecha de entrada</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', backgroundColor: 'background.paper', width: '150px' }}>Clasificación 1</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', backgroundColor: 'background.paper', width: '150px' }}>Clasificación 2</TableCell>

                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {insumos.map((insumo) => (
                                <TableRow key={insumo.id} onClick={() => ability.can('update', 'RESOURCES') && handleEditInsumo(insumo.hash_code)} sx={{ cursor: 'pointer' }}>
                                    <TableCell onClick={(e) => e.stopPropagation()}>
                                        {ability.can('delete', 'RESOURCES') && (
                                        <Checkbox
                                            color="secondary"
                                            checked={selectedInsumoToDelete.includes(insumo.id)}
                                                onChange={(e) => handleCheckboxChange(insumo.id)}
                                            />
                                        )}
                                    </TableCell>
                                    <TableCell>{insumo.is_active ? <Chip label="Si" color="success" sx={{ fontWeight: 'bold' }} /> : <Chip label="No" color="error" sx={{ fontWeight: 'bold' }} />}</TableCell>
                                    <TableCell>{insumo.code}</TableCell>
                                    <TableCell>{insumo.name}</TableCell>
                                    <TableCell>{insumo.amount}</TableCell>
                                    <TableCell>{insumo.unit}</TableCell>
                                    <TableCell>{insumo.type_insumo?.name}</TableCell>
                                    <TableCell>{locationString(insumo.location)}</TableCell>
                                    <TableCell>{insumo.description}</TableCell>
                                    <TableCell>{insumo.date_entry}</TableCell>
                                    <TableCell>{insumo.classification1?.value}</TableCell>
                                    <TableCell>{insumo.classification2?.value}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>

            </Box>

            <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', mt: 2, }}>
                <TablePagination
                    rowsPerPageOptions={[20, 50, 100]}
                    component="div"
                    count={pagination.count || 0}
                    rowsPerPage={pagination.per_page || 20}
                    page={(pagination.current_page || 0) - 1}
                    onPageChange={(event, newPage) => {
                        console.log(pagination)
                        setPagination({ ...pagination, current_page: newPage });
                        getInsumos({ ...pagination, page: newPage + 1, ...filtersData });
                    }}
                    onRowsPerPageChange={(event) => {
                        setPagination({ ...pagination, per_page: parseInt(event.target.value) });
                        getInsumos({ ...pagination, page: 1, per_page: event.target.value, ...filtersData });
                    }}
                    labelRowsPerPage="Registros por página"
                    sx={{
                        "& .MuiTablePagination-root": {
                            display: 'flex',
                            justifyContent: 'flex-start',
                            alignItems: 'center',
                            mt: 2
                        }
                    }}
                />
            </Box>
        </>
    )
}